import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";

const HotelInfo = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();

  const itemsStr = get("hotel_info_items");
  const items = itemsStr ? itemsStr.split("\n").filter(Boolean) : t.hotelInfo.items;

  return (
    <section className="hotel-section bg-secondary">
      <div className="hotel-container max-w-3xl mx-auto">
        <h2 className="font-display text-2xl md:text-3xl font-semibold text-foreground mb-6">
          {get("hotel_info_heading") || t.hotelInfo.heading}
        </h2>
        <ul className="space-y-2 mb-8">
          {items.map((item, i) => (
            <li key={i} className="font-body text-sm text-foreground/80 leading-relaxed flex gap-2">
              <span className="text-foreground/40 mt-1">•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
        <div className="flex flex-wrap items-center gap-6 md:gap-10 mb-8">
          <div className="flex items-center gap-2">
            <Clock className="w-5 h-5 text-foreground/60" />
            <span className="font-body text-sm font-semibold text-foreground">Check-out: {get("checkout_time") || "07:00 – 11:00"}</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock className="w-5 h-5 text-foreground/60" />
            <span className="font-body text-sm font-semibold text-foreground">Check-in: {get("checkin_time") || "16:00 – 22:00"}</span>
          </div>
        </div>
        <Link
          to="/rooms"
          className="inline-flex items-center justify-center px-8 py-3 bg-primary text-primary-foreground font-body text-sm uppercase tracking-[0.15em] font-medium hover:bg-primary/90 transition-colors rounded-sm"
        >
          {get("hotel_info_view_rooms") || t.hotelInfo.viewRooms}
        </Link>
      </div>
    </section>
  );
};

export default HotelInfo;
